import { render, staticRenderFns } from "./ChapterContentCard.vue?vue&type=template&id=40336249&scoped=true&"
import script from "./ChapterContentCard.vue?vue&type=script&lang=js&"
export * from "./ChapterContentCard.vue?vue&type=script&lang=js&"
import style0 from "./ChapterContentCard.vue?vue&type=style&index=0&id=40336249&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40336249",
  null
  
)

export default component.exports